
import axios from "axios";
import { store } from "store";
import { OutputBaseProps, PaginationProps } from "utils/types/API";
import { PageItemProps } from ".";
import { loading, index, options, publishPages } from "store/page";

interface ApiPageInputProps {
    page?: number;
    pageSize?: number;
    q?: string;
    publish?: boolean;
}

type ApiPageOutputProps = OutputBaseProps<{ list: PageItemProps[]; pagination?: PaginationProps; }>

export const apiPageIndex = async (data: ApiPageInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiPageOutputProps>("/api/pages", { params: data }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(index({ data: res.data.list, pagination: res.data.pagination }));
    }
    return res;
};

export const apiPageOptions = async (data: { q?: string; }) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiPageOutputProps>("/api/pages", { params: { ...data, fields: "id,code,name,url" } }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(options({ data: res.data.list }));
    }
    return res;
};


export const apiPagePublishPages = async () => {
    const res = (await axios.get<ApiPageOutputProps>("/api/page/publish",))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(publishPages({ data: res.data.list }));
    }
    return res;
};
